import React from "react";
import { ConfirmMessage, ConfirmTitle, IconWrap } from "./styled";

import { Modal, ModalBody, ModalHeader, ModalFooter } from "components/ui/Modal";
import BasicButton from "components/forms/BasicButton";


const BasicModal = ({children, title, actions, confirm_click, cancel_click, confirm_text = "Yes", cancel_text = "No", submitting,  size = "sm", centered = true, icon }: any) => {
  
  return (
    <Modal isOpen={true} toggle={cancel_click} size={size} centered={centered}>
      {title &&            
        <ModalHeader toggle={cancel_click}></ModalHeader>
      }
      {children &&
        <ModalBody>
          {icon && <IconWrap>{icon}</IconWrap>}
          <ConfirmTitle>{title}</ConfirmTitle>
          <ConfirmMessage>{children}</ConfirmMessage>
        </ModalBody>
      }
      <ModalFooter>
        {typeof cancel_click === "function" &&
          <BasicButton 
            type="button" 
            outline={true}               
            onClick={cancel_click} 
            styles={{margin: !actions && !confirm_click ? ".25rem 0 .25rem 0" : "0px 10px .25rem 0"}}
            scheme="secondary"
          >{cancel_text}</BasicButton>
        }
        {actions}
        {typeof confirm_click === "function" &&
          <BasicButton
            type="button"          
            onClick={confirm_click} 
            $submitting={submitting}
          >{confirm_text}</BasicButton>   
        }             
      </ModalFooter>
    </Modal>
  );
};

export default BasicModal;